import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import SoundSelection from './SoundSelection';
import HeadsetSelectionScreen from './HeadsetSelectionScreen';

const SoundSelectionMain = () => {
    const {
        pageObject: { isMicSelected },
    } = useSelector((state: RootState) => state.appConfigSlice);
    return (
        <>
            {isMicSelected ? (  
                <SoundSelection />
            ) : (
                <HeadsetSelectionScreen />  
            )}
        </>
    );
};

export default SoundSelectionMain;